<template>
  <div v-if="items.length">
    <div v-if="xs" class="page-home-featured-mobile">
      <carousel
        ref="carousel"
        :perPage="1"
        autoplay
        autoplayHoverPause
        :autoplayTimeout="carouselTimeout"
        loop
      >
        <slide
          v-for="({ id, title, img, category, date }, i) in slicedItems"
          :key="i"
        >
          <ArticleCard
            :id="id"
            :title="title"
            :img="img"
            :date="date"
            :category-title="category.title"
            :category-color="category.color"
            type="featured"
          />
        </slide>
      </carousel>
    </div>
    <div v-else class="page-home-featured-desktop grey lighten-4">
      <ArticleCard
        v-for="({ id, title, img, category, date }, i) in slicedItems"
        :key="i"
        :id="id"
        :title="title"
        :img="img"
        :date="date"
        :category-title="category.title"
        :category-color="category.color"
        type="featured"
      />
    </div>
  </div>
</template>

<script>
import ArticleCard from "@/components/cards/article/Index.vue";
import { carouselFeaturedCount, carouselTimeout } from "@/config.js";

const _config = {
  mod: "articles",
};

export default {
  data: () => ({
    items: [],
    carouselTimeout,
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    lg() {
      return this.$vuetify.breakpoint.lgAndDown;
    },
    itemsPerPage() {
      if (this.xs) return carouselFeaturedCount;
      else if (this.sm) return 4;
      else if (this.md) return 6;
      else if (this.lg) return 8;
      else return 10;
    },
    slicedItems() {
      return this.items.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    formatDate(str) {
      const dateTimeFormat = new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      return dateTimeFormat.format(new Date(str.replace(/\s/, "T")));
    },
  },
  mounted() {
    const params = {
      itemsPerPage: this.itemsPerPage,
      featuredHome: 1
    };

    if (this.$route.query['data-atual']) params.todayDate = this.$route.query['data-atual'];

    this.$rest(_config.mod)
      .get({ params })
      .then((data) => (this.items = data));
  },
  components: {
    ArticleCard,
  },
};
</script>

<style>
/* ### MOBILE ### */
.page-home-featured-mobile {
  position: relative;
}
.page-home-featured-mobile .owl-nav {
  display: none;
}

.page-home-featured-mobile .VueCarousel-pagination {
  position: absolute;
  bottom: 16px;
  left: 54px;
  right: 54px;
  z-index: 100;
  display: flex;
  justify-content: center;
  width: calc(100% - 108px) !important;
}

.page-home-featured-mobile .VueCarousel-dot-container {
  margin-top: 0 !important;
}

.page-home-featured-mobile .VueCarousel-dot {
  background-color: transparent !important;
  margin-left: 8px !important;
  margin-right: 8px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  height: 10px !important;
  width: 10px !important;
  border: 1px solid white !important;
  outline: none !important;
}
.page-home-featured-mobile .VueCarousel-dot.VueCarousel-dot--active {
  background-color: white !important;
  border: 1px solid white !important;
}

@media screen and (max-width: 600px) {
  .page-home-featured-mobile .VueCarousel-pagination {
    top: 12px;
    bottom: initial;
  }

  .page-home-featured-mobile .VueCarousel-dot {
    background-color: white !important;
    border: none !important;
  }

  .page-home-featured-mobile .VueCarousel-dot.VueCarousel-dot--active {
    background-color: var(--v-secondary-base) !important;
    border: none !important;
  }
}

/* ### DESKTOP ### */
.page-home-featured-desktop {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr 1fr;
}

@media screen and (max-width: 1904px) {
  .page-home-featured-desktop {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (max-width: 1264px) {
  .page-home-featured-desktop {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 960px) {
  .page-home-featured-desktop {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
